<app-header></app-header>
<ba-oiam-oauth></ba-oiam-oauth>

<main class="main">
    <header class="ba-content-header ba-with-overlay ba-with-image ba-full-width">
        <div class="ba-header-image odbs-header"></div>
        <div class="ba-content-wrap">
            <div class="ba-overlay">
                <div class="logo"></div>
                <h1 id="ct_header_txt">Online-Dialog Bezügestellen</h1>
                <p id="ct_headerText_txt">Herzlich Willkommen beim Online-Dialog Bezügestellen der Familienkasse</p>
            </div>
        </div>
    </header>

    <div class="container-fluid" #containerElement>
        <router-outlet></router-outlet>
    </div>
</main>

<app-spinner *ngIf="isLoading$ | async"></app-spinner>

<app-footer></app-footer>
